<template>
  <div class="text-right publish-sign">
    <div class="upload-file">
      <template v-if="this.$store.getters.authUser.identityAuth > -1">
        <!-- style="margin-left: 15px !important;" -->
        <div class="sign_color" :size="size" @click="toFile" type="primary">
          <img class="hover_add_img" src="../../static/images/home/add.png" alt="">
          <img class="add_img" src="../../static/images/home/add_red.png" alt="">
          <span>{{fileText}}</span>
        </div>
      </template>
      <template v-else>
        <!-- style="margin-left: 15px !important;" -->
        <div
          class="sign_color"
          :size="size"
          type="primary"
          @click="authFn"
          >
          <img class="hover_add_img" src="../../static/images/home/add.png" alt="">
          <img class="add_img" src="../../static/images/home/add_red.png" alt="">
          <span>{{fileText}}</span>
        </div>
      </template>
    </div>

    <el-dialog :visible.sync="authDialog" title="实名认证" width="475px">
      <p class="authDialog">
        <img
          src="../../static/images/warning.png"
        />您还未完成实名认证，认证后才能执行该操作。
      </p>
      <template slot="footer">
        <el-button
          style="border: none; background: #ec1c1c; color: #ffffff"
          size="small"
          @click="gotoAuth"
          >去认证</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { isInDingTalk } from "../../assets/js/utils/ding-env";

function getStore () {
  return Vue.prototype.$storeInstance;
}
export default {
  data () {
    return {
      loading: null,
      authDialog: false
    };
  },
  methods: {
    authFn() {
      this.$confirm(
        "您的账号还未完成实名认证，无法使用完整功能！",
        "提示",
        {
          confirmButtonText: "去认证",
          cancelButtonText: "以后再说",
          type: "warning"
        }
      )
        .then(() => {
          this.gotoAuth();
        })
        .catch(() => {
        });
    },
    gotoAuth () {
      if (+getStore().getters.authUser.userType === 0) {
        getStore().$router.push("/auth/personalIdentityAuth");
      } else {
        getStore().$router.push("/auth/authGuide");
      }
    },
    // 前往模板列表发起模板签署
    toTpl: function () {
      let { href } = this.$router.resolve({ path: "/tpl/general" });
      isInDingTalk ? location.href = href : window.open(href, "_blank");
    },
    // 前往多文件发起签署
    toFile: function () {
      let { href } = this.$router.resolve({ path: "/initiation/toCreate" });
      if (isInDingTalk) {
        this.$router.push({ path: "/initiation/toCreate" });
      } else {
        window.open(href, "_blank");
      }
    }
  },
  props: {
    size: {
      type: String,
      default: "small"
    },
    fileText: {
      type: String,
      default: "文件发起签署"
    },
    tplText: {
      type: String,
      default: "模板发起签署"
    }
  },
  name: "publish-sign"
};
</script>

<style lang="less" scoped>
.fx-box {
  flex: none;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    margin-left: 10px;
    font-weight: bolder;
    text-align: left;
  }

  img {
    width: 75px;
    height: 75px;
  }

  &:hover {
    p {
      color: rgba(236, 28, 28, 1);

      &:last-of-type {
        color: rgba(236, 28, 28, 0.45);
      }
    }
  }
}
.sign_color {
  border-radius: 30px;
  background: rgba(236,28,28,0.15);
  color: #ec1c1c;
  height: 30px;
  line-height: 30px;
  width: 123px !important;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin-left: 17% !important;
  .add_img {
    max-width: 15px;
    margin-right: 5px;
    vertical-align: sub;
    margin-bottom: 2px;
  }
  .hover_add_img {
    display: none;
  }
  &:hover {
    background-color: #ec1c1c;
    color: #ffffff;
    .hover_add_img {
      display: inline-block;
      max-width: 15px;
      margin-right: 5px;
      vertical-align: sub;
      margin-bottom: 2px;
    }
    .add_img {
      display: none;
    }
  }
}
.tpl {
  margin-left: 10%;
  vertical-align: top;
}
.upload-file {
  position: relative;
  display: inline-block;
  // margin-bottom: 10px;
  margin-right: 20px;
  overflow: hidden;

  input[type="file"] {
    position: absolute;
    left: -68px;
    top: 0;
    width: 200px;
    height: 200px;
    opacity: 0;
    cursor: pointer;
  }

  &:hover .el-button {
    opacity: 0.7;
  }
}
.tpl.el-button:hover {
  opacity: 0.75;
  background: #290202 !important;
  border-color: #290202 !important;
}
.tpl.el-button.active,
.tpl.el-button:focus {
  background: #290202 !important;
  border-color: #290202 !important;
}
.authDialog {
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-left: 40px;
  margin-bottom: 60px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(41, 2, 2, 0.65);

  img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
}
/deep/ .el-button--small:hover {
  opacity: 0.7 !important;
}
</style>



// WEBPACK FOOTER //
// components/publish-sign/sign.vue